import { render, staticRenderFns } from "./TaskNewFrSite.vue?vue&type=template&id=78f63a31&"
import script from "./TaskNewFrSite.vue?vue&type=script&lang=js&"
export * from "./TaskNewFrSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports